/* SeoulSend — header drawer (mobile)
   - hamburger toggles a full-screen drawer under the header bar
   - locks page scroll and hides Crisp while open
   - closes on Esc, on link tap, and when resizing to desktop */
(function () {
  function init(root) {
    if (!root || root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    var btn = root.querySelector('.ss-burger');
    var drawer = root.querySelector('.ss-drawer');
    if (!btn || !drawer) return;

    var html = document.documentElement;

    function crisp(action) {
      try {
        if (window.$crisp && typeof window.$crisp.push === 'function') {
          window.$crisp.push(['do', action]);
        }
      } catch (e) { /* Crisp not loaded */ }
    }

    function setTop() {
      var bar = root.querySelector('.ss-header__bar');
      if (bar) {
        var r = bar.getBoundingClientRect();
        drawer.style.setProperty('--ss-drawer-top', Math.max(0, r.bottom) + 'px');
      }
    }

    function open() {
      setTop();
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', btn.dataset.labelClose || 'Close menu');
      html.classList.add('ss-locked');
      crisp('chat:hide');
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', btn.dataset.labelOpen || 'Open menu');
      html.classList.remove('ss-locked');
      crisp('chat:show');
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') close(); else open();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        close();
        btn.focus();
      }
    });

    var mq = window.matchMedia('(min-width: 768px)');
    var onChange = function (ev) { if (ev.matches) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // Theme editor re-renders the section; start closed.
    close();
  }

  function boot() {
    document.querySelectorAll('[data-ss-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-ss-header]');
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('ss-locked');
  });
})();
